export default {
  "1.14.4": {
    date: "10 Jul 2023",
    fix: [],
    improvement: [
      "Allowing custom ID when cloning project."
    ],
    feature: []
  },
  "1.14.3": {
    date: "13 Feb 2023",
    fix: [
      "Fixes graph filter menu issue for smaller screen resolutions.",
    ],
    improvement: [],
    feature: []
  }
  "1.14.2": {
    date: "7 Feb 2023",
    fix: [
      "Fixes hidden 'Open in type view' context menu action.",
    ],
    improvement: [],
    feature: [
      "Adds open in graph view for attributes and relations meta queries."
    ]
  }
  "1.14.1": {
    date: "18 Jan 2023",
    fix: [
      "Fixes 'Expand Node' bug due to left panel re-render.",
      "Fixes 'Show node in graph' context menu action.",
      "Fixes 'Open type in type view' context menu action."
    ],
    improvement: [],
    feature: []
  }
  "1.14.0": {
    date: "12 Jan 2023",
    fix: [
      "Fixes relation nodes not showing.",
      "Closes create node view modal when user browses away from it through sidebar, to avoid hiding it in chrome.",
      "Prevents branch switching when using hot key to fire graph console query."
    ],
    improvement: [
      "Adds option create sub node from left panel.",
      "Adds option to edit node via form, by right clicking on the left panel nodes.",
      "Adds form validation to forms."
    ],
    feature: [
      "Adds possibility to set default value on string, switch and number form fields in forms.",
      "Adds right clicking empty space in instance tree to create node.",
      "Adds embeddable graph view.",
      "Adds ability to size nodes and relations based on attributes."
    ]
  }
  "1.13.1":
    date: "15 Sep 2022"
    feature: []
    fix:[
      "Prevents redering a node as a hexagon when viewing relation nodes."
    ]
    improvement: []
  "1.13.0":
    date: "29 Jul 2022"
    feature: []
    fix:[
      "Id in forms is only allowed to be of type string."
      "Stores list of types for nodes in graph data."
      "Shows the nodes correctly in TreeView if selectRecursiveIn all was selected."
      "Limits relations in left panel the same as the graph."
      "Adds expanding nodes in the tree for weaver queries with selectIn."
    ]
    improvement: [
      "Collects all macros related to a node based on the multiple types it has."
      "Adds macros/forms under Space/Settings."
      "Adds DateTime input for forms."
      "Makes changelog component hidden by default."
      "Adds visual cue to show if instance tree results are limited."
      "Makes query config field of Form to have full width."
    ]
  "1.12.1":
    date: "22 Jun 2022"
    feature: []
    fix:[
      "Fixes the disappearance of Edit via Form option from graph context menu."
    ]
    improvement: []
  "1.12.0":
    date: "2 Jun 2022"
    feature: []
    fix:[
      "Prevents error screen when logging out from spaces page."
      "Returns name attribute as a label of a View by default if name key is not set."
      "Updates Macros list state, on delete and this reflects on right panel."
      "Updates macro in state after getting edited."
      "Shows 'Edit via Form' on types nodes."
      "Hides 'Edit via Form' on relations."
      "Selects correct namespace value when saving a node."
    ]
    improvement: [
      "Collects typesMap faster, using meta query types."
      "Adds validation when saving namespaces."
      "Repositions the step controls inside 'Steps & Fields' view when creating a new Form."
      "Expands node details on click."
    ]
  "1.11.2":
    date: "19 Apr 2022"
    feature: []
    fix: [
      "Caters for identical uids but seperate graphs."
      "Allows searching of nodes with empty namespaces."
      "Represents selectInMinus / selectOutMinus correctly in the left panel."
      "Makes nodes with only disabled relations visible."
    ]
    improvement: [
      "Adds support.weaverhq link to the to the support modal."
    ]
  "1.11.1":
    date: "31 Mar 2022"
    feature:[]
    fix:[
      "Checks if signup enabled is true instead of not undefined."
    ]
    improvement: []
  "1.11.0":
    date: "30 Mar 2022"
    feature:[
      "Adds user sign up page."
    ]
    fix:[
      "Fixes setting the correct relation name when editing a Form with select or create type of field."
      "Prevents navigation to acl route via URL unless user has acl privilege."
      "Fixes search function on select or create field."
      "Fixes searching select options in Forms."
      "Allows removing entry from multiselect in Forms."
    ]
    improvement: [
      "Shows node graph in separate field."
      "Disables actions in EntityListContainer when user has no access."
      "Shows node graph in separate field."
      "Improves UX accessing node details popover."
      "Does not store multiple key presses in Weaver History."
      "Hides default graph from filter list when empty."
      "Remembers when data is colored by graph or type."
      "Applies namespace to Id's when required in Forms."
    ]
  "1.10.2":
    date: "9 Mar 2022"
    feature: [],
    fix: [
      "Fixes 'Change Password' input for dark mode."
      "Prevents user from transforming attribute or relation keys if the project is frozen."
    ],
    improvement: [
      "Substitutes prefix for full URI for attr and relation keys."
      "Hides 'Unable to update project' message when no migration has to be executed."
      "Allows user to create 'medium' strength passwords and improves feedback."
      "Supports the wvr:fileId datatype."
    ]
  "1.10.1":
    date: "25 Feb 2022",
    feature: [],
    fix: [],
    improvement: [
      "Shows a dot if node is a type and tag if node is in a graph in Form select inputs."
      "Updates the sparql documentation link and renders it as clickable url."
      "Allows generic/untyped Forms creation."
    ]
  "1.10.0":
    date: "16 Feb 2022",
    feature: [],
    fix: [
      "Fixes handling multiple member keys and prevents from showing typed nodes in untyped tab of table view."
      "Fixes nodes missing in spreadsheet view and improves handling maximum tab limit."
      "Fixes resetting '$config' branch when a user navigates away from branches page."
      "Fixes dark mode for autofill, input, date picker, select UI."
      "Fixes failure when editing a Form."
      "Fixes visibility of Forms and services in left panel if user does not have write access."
    ],
    improvement: [
      "Adds save as view option to the graph console."
    ]
  "1.9.1":
    date: "9 Feb 2022",
    feature: [],
    fix: [],
    improvement: [
      "Improves performance of graph console."
    ]
  "1.9.0":
    date: "31 Jan 2022",
    feature: [
      "Adds filter panel to Users component.",
      "Allows sign in with email."
    ],
    fix: [
      "Removes limit on select field in Forms."
      "Fixes incoming and outgoing relations in Forms."
      "Fixes missing graphed nodes in relation select options in Forms."
    ],
    improvement: [
      "Allows QueryBuilder or Sparql when creating graph views."
      "Allows graph specification in Forms."
      "Allows filtering by 'active' and 'domains' in ACL user list."
      "Adds UI feedback when cloning a project."
      "Adds entry for time restrictors to the query helper."
    ]
  "1.8.1":
    date: "17 Jan 2021",
    feature: [],
    fix: [],
    improvement: [
      "Allows users to save attributes as 'file' datatype."
      "Shows 'file' datatype attributes as downloadable links if they exist in minio."
    ]
  "1.8.0":
    date: "11 Jan 2021",
    feature: [],
    fix: [
      "Fixes branch/lane issue in commits tree."
      "Fixes issue when saving graph query as a view."
      "Fixes running query using keyboard shortcut."
      "Fixes the collection of all type nodes."
    ],
    improvement: [
      "Filters on default graph, in graph filter."
      "Shows whether a user is active/inactive in the acl users list."
      "Shows last login date of user in the acl users list, if data is available."
      "Adds tag to indicate that a user has domains associated with him in the users list of acl."
    ]
  "1.7.0":
    date: "15 Dec 2021",
    feature: [],
    fix: [
      "Fixes Edit Form title."
      "Fixes type, attribute and relation views not updating when switching branches."
      "Fixes auto completion in Forms query builder field."
      "Fixes issue where Forms don't respect graphs."
      "Adds tag to indicate that a user has domains associated with him in the users list of acl."
    ],
    improvement: [
      "Allows graph specification in Forms."
      "Adds ability to filter on default graph in graph filter."
      "Shows whether a user is active/inactive in the acl users list."
      "Shows last login date of user in the acl users list, if data is available."
    ]
  "1.6.0":
    date: "3 Dec 2021"
    feature: [
      "Adds ability to choose different Form when multiple are available for editing a node."
    ]
    fix: [
      "Fixes some issues regarding dark mode text readability."
      "Fixes issue when clearing spaces with protected branches."
      "Fixes some dark mode styling issues."
      "Fixes empty branch field in service creating a nameless branch."
      "Fixes issue where filtered relations would not be cleared when opening a new view in the graph."
      "Fixes issue that caused nodes to be not expandable after global search."
      "Fixes branch selection in sync-one-way."
    ]
    improvement: [
      "Changes 'Macro' to 'Form'."
    ]
  "1.5.0":
    date: "22 Nov 2021"
    feature: []
    fix: [
      "Checks if a user is authenticated when selecting a view to open by default."
      "Fixes some UI component styling."
      "Fixes user name being undefined when left panel was expanded."
      "Fixes issue where types view didn't open as expected."
      "Fixes selectOut cancelling selectIn in query parameters and vice versa."
      "Adds query type button to the console when 'run view in console' is used."
      "Shows actual query in the console when 'run view in console' is used."
      "Re-opens console when 'run view in console' is used repeatedly."
      "Fixes scrolling in the query editor."
      "Fixes dark mode styling in upload dragger and spreadsheet."
      "Fixes sorting in the spreadsheet."
    ]
    improvement: [
      "Wipe project clears everything except 'config' branch."
      "Improves feedback for users without write access."
      "Changes upload transformations file UI similar to other services."
      "Removes 'zipped' from config section of service creation form."
    ]
  "1.4.0":
    date: "1 Nov 2021"
    feature: [
      "Adds clickable link to spreadsheetview when a url is entered in a string."
      "Adds dark mode."
    ]
    fix: [
      "Fixes graph filters only being applied after opening the filter menu."
      "Fixes issue when clearing the 'key' form field in create macro form."
      "Makes graph load at same time as left panel."
      "Fixes issue when deleting domain."
      "Fixes issue where graph filter menu would hang indefinitely."
      "Prevents user from deleting global permission."
      "Fixes overlapping text for attributes in the left panel."
      "Allows only users with write permission to create merge request."
      "Allows option to run custom views in console."
    ]
    improvement: [
      "Introduces full rebranding."
      "Decreases default limitRelations for improved speed."
      "Sets minimum bar height on distribution bar chart."
      "Removes double query on all the types."
      "Makes ACL access less restrictive."
      "Hides the clear local storage button by default."
      "Allows routing to yasgui."
      "Improves spreadsheet performance by limiting the default amount of open tabs."
    ]
  "1.3.0":
    date: "19 Oct 2021"
    feature: [
      "Allows users to create public views."
    ]
    fix: [
      "Fixes issue with wrong value being sent while creating a service."
      "Fixes issue with selectRecursive(In/Out) when trying to load children in the treeview."
      "Filters duplicate disabled relations."
      "Fixes commits tree breaking when user deleted a branch."
      "Fixes new space form item placeholder having an underscore prefix."
      "Fixes 'Clear Space' button clearing current space instead of targeted one."
      "Fixes missing items in graph context menu."
    ]
    improvement: [
      "Makes lock icon state more apparent."
      "Allows spaces inside namekeys."
      "Improves UX for showing transform attribute to relation button."
      "Moves placement of left panel lock button."
      "Migrates deprecated 'importExcel' service call to 'import'."
      "Adds more intuitive form component for services."
    ]
  "1.2.0":
    date: "14 Sep 2021"
    feature: [
      "Introduces version control commits tree."
      "Allows branches to be protected in UI."
      "Introduces version control functionality to compare branches."
      "Introduces domains feature."
    ]
    fix: [
      "Fixes bug with timeslider and added option to use attributes on relations."
      "Fixes bug where interacting with node from graph had no effect."
      "Fixes bug causing 500 screen when clicking on an abstract relation."
      "Fixes bug where pressing back button would not allow user to go back to the previous space."
      "Fixes bug where memberkeys containing invalid characters generate broken sparql."
      "Fixes bug where user was given option to create node in an empty type view."
      "Fixes bug where user could not create a relation from node that’s within a graph."
      "Fixes issue loading relations and nodes."
      "Fixes a bug where clicking a node would not reveal it’s attributes."
      "Fixes filtering on date attributes in spreadsheet."
      "Fixes create space issue."
      "Removes 'open in' actions for Meta data relations."
      "Fixes validation in merge request form."
      "Fixes attributes on relations not being able to have special characters in the key."
      "Allows selecting source and target branches when creating merge request from branch list view"
      "Fixes an issue where the spreadsheet wouldn't save well unless a user had already loaded all rows."
    ]
    improvement: [
      "Allows branches to be mass deleted from the UI."
      "Improves transform attribute into relation feature."
      "Adds views to space settings menu."
      "Adds user feedback when creating a spreadsheet view without ?node in the query."
      "Improves error messaging when trying to enter a non-existing space url."
      "Removes run query in console for spreadsheet views."
      "Retry button on upload services now returns to file selection window."
      "Direct function ACL access for roles and users is now allowed."
      "Assigning multiple groups in Group Access is now possible."
      "Prevents New branch creation if branch with same name exists already."
      "Adds branch state to url."
      "Improves end to end testing."
      "Allows graph console to run sparql queries."
    ]
  "1.1.1":
    date: '3 Aug 2021'
    feature: []
    fix: [
      "Allows parentless branch to be created."
    ]
    improvement: []
  "1.1.0":
    date: '30 Jul 2021'
    feature: [
      "Adds version control feature.",
      "Adds compare and merge branch capabilities."
      "Adds graph to visualize commit history."
    ]
    fix: [
      "Fixes bug where graph filter panel was hard to see if the window was resized to smaller dimensions."
      "Fixes service config pages migration bug."
    ]
    improvement: [
      "Allows multiline text for attributes."
      "Adds versions to footer of changelog."
      "Allows filtering of relations by id in spreadsheet."
    ]
  "1.0.3":
    date: '21 Jul 2021'
    feature: []
    fix: [
      "Fixes users and spaces not saving as expected."
      "Adds DISTINCT to Weaver.Sparql queries."
    ]
    improvement: []
  "1.0.2":
    date: '14 Jul 2021'
    feature: []
    fix: []
    improvement: [
      'Reinforces bootstrap process'
    ]
  "1.0.1":
    date: '12 Jul 2021'
    feature: []
    fix: [
      "Fixes sdk issue."
      "Fixes file download links not working."
    ]
    improvement: []
  "1.0.0":
    date: '9 Jul 2021'
    feature: [
      "Adds Space Synchronisation Action page."
      "Adds Instantiate type context menu option for Types items in the tree."
      "Adds UI for git branch selection"
    ]
    fix: [
      "Fixes an issue where the spreadsheet would initially not render certain rows."
      "Fixes an issue concerning relationNodes in the graph view."
      "Fixes a bug where right clicking a large number of nodes in graph view would fail."
      "Fixes bug where macro function wouldn't accept negative values."
      "Fixes bug where creating a new macro would retain information from one previously made."
      "Fixes a bug where refreshing the page was required in order to have 'clear local storage' option."
      "Fixes bug where graph filter menu wasn't scrollable."
      "Fixes 500 page being shown when clearing a space."
      "Fixes hide/show Id column menu item in table view."
      "Removes obstructed back button in create view."
      "Fixes bootstrap bug where Weaver Service was undefined."
      "Fixes spreadsheet error where empty dataset would cause infinite spinner."
      "Fixes bug where Ctrl + D didn't open graph console on windows devices."
      "Fixes duplicate relation key options in relation picker component."
      "Fixes JSON attribute datatype changing after editing in the left panel."
      "Fixes turtle download button broken issue."
      "Fixes Users and Spaces not saving well when edited."
      "Fixes issue where relation nodes in different graphs were not being shown."
    ]
    improvement: [
      "Improves loading time of some project meta to make project-changing generally less sluggish."
      "Improves column-sizing UX for spreadsheet."
      "Allows filtering relations on id as well as label."
      "Improves lots of spreadsheet error-handling."
      "Adds new layout for left panel."
      "Adds scrollbar for uploaded data history."
      "Adds json datatype to node attributes."
      "Makes table scrollbars thicker."
      "Allows custom selects in table config."
      "Shows relation created/creator in the same way as on nodes."
      "Provides user feedback if multiple users try to add/remove the same disabled items."
      "Moves config data from $config graph to $config branch"
    ]
  "0.5.8":
    date: '25 May 2021'
    feature: [
    ]
    fix: [
      "Fixes clearing date cell in table view."
      "Fixes right clicking a large number of nodes in graph view would fail."
      "Fixes macro function wouldn't accept negative values."
      "Fixes creating a new macro would retain information from one previously made."
      "Fixes refreshing the page was required in order to have 'clear local storage' option."
      "Fixes forwarding remote ip address for audit logging."
    ]
    improvement: [
      "Adds scrollbar for uploaded data history."
      "Adds json datatype to node attributes."
      "Makes table scrollbars thicker."
    ]
  "0.5.7":
    date: '17 May 2021'
    feature: []
    fix: [
      "Fixes a bug where edit state in table view wasn't being stored correctly."
      "Fixes a bug in the 3d graph."
      "Fixes a number cell input issue in the table view."
      "Fixes issue causing public spaces to hang."
      "Fixes bug where clicking `save` very quickly on the edit node view would trigger a 500 page."
      "Fixes an issue where the select-or-create inputs in Macros couldn't find the data used to render the proceeding form."
      "Fixes an issue where you couldn't have select-or-create inputs with multiple targets."
      "Fixes an issue where read-only users could still see Macros (despite not being able to use them)."
    ]
    improvement: []
  "0.5.6":
    date: '7 May 2021'
    feature: [
      "Adds support for config of date ranges."
      "Adds support for repeating items (Macros)."
      "Adds support for end date in timeslider."
      "Adds support for creating relation key aliases."
      "Adds new Services template which allows passing dynamic json."
    ]
    fix: [
      "Fixes an issue where the last entry of a table with size over 30 wasn't shown."
      "Fixes a sequenced form bug."
      "Removes an obsolete component."
      "Fixes date picker alignment in table filter."
      "Fixes flashing edit icon when hovering over multiline attribues."
      "Fixes hanging save button when creating a node with exisiting identifier in create node view."
      "Ignores config data when editing relation keys."
      "Fixes wrong default query for created spreadsheet views."
      "Fixes bug with backwards compatible macros."
      "Fixes filters in the table view."
      "Fixes bug regarding types and relation filters in graph filter panel."
      "Fixes a rounding bug with time period inputs in a Service."
      "Fixes searching the 3d graph for empty value."
    ]
    improvement: [
      "Improves description quality for service templates."
      "Adds confirmDelete for deleting macros."
      "Allows nodes with user specified ids to be created from the table view."
      "Makes Macros be optionally hidden (from the home tree)."
      "Allows specifying an attribute to be used for filtering relation targets in macro fields."
      "Adds new macro field type: 'radio'."
      "Adds optional multiselect for select and selectOrCreate macro fields."
      "Gives user the option to clear local storage if 500 error screen is shown."
      "Improves Services configuration from the UI."
    ]
  "0.5.5":
    date: '12 Apr 2021'
    feature: []
    fix: [
      "Fixes issue preventing user from being able to scroll in the graph filter."
      "Fixes an issue where app would crash when clearing a date attribute in table view."
      "Fixes issue where table filter menu would be partially obstructed in last column of the view."
    ]
    improvement: [
      "Removes an attribute in the table view, if the attribute value is set to be empty."
      "Colours of instances in graph view are now more distinguishable than before"
    ]
  "0.5.4":
    date: '25 Mar 2021'
    feature: []
    fix: [
      "Fixes an issue where user mode reverted after a refresh."
    ]
    improvement: [
      "Adds a bit more space to the settings page to prevent overlap."
    ]
  "0.5.3":
    date: '23 Mar 2021'
    feature: [
      "Adds totally new Create View user experience."
      "Adds user profile modes Simple, Advanced and Expert."
      "Allows types to be filtered out by default in Disabled Types setting."
      "Allows default relation and type filtering to be adjusted from filter menu."
      "Allows changing the relation and attribute keys for all."
      "Allows the color for 'color by graph feature' to be adjusted."
    ]
    fix: [
      "Fixes the 3D graph rendering when a filter was active."
      "Fixes the random graph loading after clicking a relation or attribute."
      "Fixes various bugs in the Service configuration."
    ]
    improvement: [
      "Improves UI design in consistency."
      "Moves Show ID in table to the 'more' settings."
      "Moves Creator and Created metadata to the ID popover."
    ]
  "0.5.2":
    date: '10 Mar 2021'
    feature: [
      "Adds Inline editing of attribute value in the detail panel."
    ]
    fix: [
    ]
    improvement: [
      "Allows the Service upload page to be re-run and show the recent uploads."
    ]
  "0.5.1":
    date: '6 Mar 2021'
    feature: [
    ]
    fix: [
    ]
    improvement: [
      "Updates the Weaver SDK."
    ]
  "0.5.0":
    date: '5 Mar 2021'
    feature: [
      "Adds Organisation support in ACL."
      "Allows configuring your own set of Services through space settings."
      "Allows reversing a relation via the context menu."
      "Allows renaming a relation via the context menu."
      "Adds namespace translation checkbox in Create Node."
      "Allows configuring Disabled relations in Space settings."
      "Adds clickable URL to a node ID if it matches a URL."
      "Weaver Synth allows for making music with Weaver :)"
      "Adds a SPARQL TSV import profile."
    ]
    fix: [
      "Fixes create relation to continue after dragging."
      "Fixes Open nodes in table to break for multiple types."
      "Text in settings such as Member Key is now selectable."
      "Fixes Namespace searching after the colon."
      "Fixes labels containing only a number from showing in the graph."
      "Adds config types to be hidden when set in Space Settings."
      "Fixes WeaverQuery parse error when Tree query left empty."
      "Fixes an issue when switching from Types to Relations."
      "Fixes the limit on Attributes at maximum of 1000."
      "Fixes a bug where editing a view would jump to space."
      "Various small fixes."
    ]
    improvement: [
      "Shareable URL of elements follow RDF standards."
      "Opening current Graph in Table respects the filter settings."
      "Greatly improves the Create Relation selection boxes."
      "Improves visibility of URL in Node ID."
      "Sorts views alphabetically."
      "Improves Excel importer supporting relation creation."
      "Space sorting in selection list ignores case."
      "Opens a node if the ID is an URL in a new tab."
      "Adds progress bar and better feedback on Clearing Space action."
      "Shows progress bar during Uploading files."
      "Adds a Support button for contacting details."
      "Adds the option to hide nodes when searching in the graph."
    ]
  "0.4.20":
    date: '21 Dec 2020'
    feature: [
      "Changes and persist node size of a type."
    ]
    fix: [
      "Fixes an issue with type color on multiple types."
    ]
    improvement: [
    ]
  "0.4.19":
    date: '17 Dec 2020'
    feature: [
    ]
    fix: [
      "Fixes infinite loading spinner on startup."
    ]
    improvement: [
    ]
  "0.4.18":
    date: '16 Dec 2020'
    feature: [
      "Changes and persist colors of a type."
      "Adds Open view by default setting when loading a space."
      "Adds Create and open View as a Spreadsheet."
      "Adds Expand all nodes of a certain type in the Graph view."
    ]
    fix: [
      "Fixes an issue where not all tree relations in would show."
      "Fixes an isssue where deleting a user would throw an error."
      "Fixes an issue where bootstrapping a project would sometimes fail."
      "Adds temporary fix for Save View as Graph to ignore nodes in a graph."
      "Fixes Namespacing for blank nodes."
      "Fixes a certain error when saving a View."
      "Fixes an issue where creating an Element with empty id or graph would crash."
    ]
    improvement: [
      "Improves the Graph Time Slider greatly."
      "Shows a count for types elements in the tree as Relations and Attributes."
      "Improves the search results when searching for target nodes."
      "Improves Machine Learning result parsing."
    ]
  "0.4.17":
    date: '5 Dec 2020'
    feature: [
      "Adds experimental version of the Graph Time Slider."
    ]
    fix: [
      "Fixes an issue with the Table view crashing to 500."
      "Fixes an edit button bug on the Type attributes view."
      "Fixes an issue where the status logging in the Action Page would overflow the popup."
    ]
    improvement: [
      "Improves ACL button notations for better understanding."
      "Adds only showing relations defined in selectIn and selectOut in Views."
      "Shows the full ID of relations in the Types view."
    ]
  "0.4.16":
    date: '1 Dec 2020'
    feature: [
      "Adds a 'Color by graph' option in the filter menu."
      "Adds a Copy button in the ID tooltips to copy without style."
      "Adds Run a View in the Graph Console through the View context menu."
      "Adds Edit a View through the View context menu."
    ]
    fix: [
      "Fixes graph filtering in the Type view."
      "Fixes a crash when opening the Graph Console with no Space selected."
    ]
    improvement: [
      "Adds better relation overlay visibility in the Type view."
      "Improves the Hierarchical Graph visualisation option."
    ]
  "0.4.15":
    date: '27 Nov 2020'
    feature: [
      "Adds Machine Learning support using the Pythia engine."
      "Adds Shift+drag and Ctrl+click for multiselect node and relation operations."
      "Adds a new Hierarchical Graph visualisation option."
      "Adds quick navigation routes from a relation panel in the types view."
      "Adds the ability to save a graph as a transparent PNG file."
      "Adds a Attributes view in the Home panel."
    ]
    fix: [
      "Removes the unfunctional edit button in type attribute panel."
      "Fixes an issue while clicking on a relation in the type view."
    ]
    improvement: [
      "Groups Space Functions within the Space tab."
      "Adds better support for hiding configuration data in the $config graph."
      "Shows a notification when Space bootstrap fails for readonly users."
      "Adds a Delete button in the Space ACL tab."
    ]
  "0.4.14":
    date: '19 Nov 2020'
    feature: [
      "Adds a new 'Save View' graph context menu option."
      "Allows Elements to be shown and added in a visible graph."
    ]
    fix: [
      "Fixes filtering on multiple member keys."
      "Fixes opening all nodes in table for second member key."
      "Fixes an issue where creating a space would use unexpected default settings."
    ]
    improvement: [
      "Improves Clear space to not clear the space configuration."
      "Disablea write context options for read-only users in table."
      "Allows Elements with ID as a namespace to show the full name."
    ]
  "0.4.13":
    date: '17 Nov 2020'
    feature: [
      "Adds Namespace support through Space Settings."
    ]
    fix: [
      "Fixes Transform Script action page with default config."
    ]
    improvement: [
    ]
  "0.4.12":
    date: '16 Nov 2020'
    feature: [
      "Allows inserting new rows to Spreadsheet."
      "Adds clickable attribute distribution value of a type."
    ]
    fix: [
      "Fixes broken type view attribute distribution."
      "Fixes the Spreadsheet miscounting datasets with two members."
    ]
    improvement: [
      "Sets the minimum Spreadsheet size is at 30 rows."
      "Adds better defaults-setting in Spreadsheet cell components."
      "Adds various other improvements on the Spreadsheet."
    ]
  "0.4.11":
    date: '13 Nov 2020'
    feature: [
    ]
    fix: [
      "Fixes filter not properly overlaying the console in the Graph Console."
      "Opens the tree when running a query in the Graph Console."
      "Fixes the run button for the Graph Console."
      "Fixes sorting the types list alphabetically."
      "Fixes an issue where switching spaces using multiple member keys would throw an error."
    ]
    improvement: [
      "Adds user rights to be automatically set after Space creation."
    ]
  "0.4.10":
    date: '12 Nov 2020'
    feature: [
      "Adds a Graph Console to interactively run queries."
      "Adds a Relations view in the Home panel."
      "Allows adding multiple member keys in Space Settings."
      "Allows creating `n` nodes in the create node panel."
      "Adds an Upload Turtle action page."
    ]
    fix: [
      "Fixes the Graph flickering with one element having many relations."
      "Fixes Space role settings not updating the user settings."
      "Fixes misalignment of an Action Page on large screens."
      "Fixes an issue with destroying a node after global search."
      "Fixes issue where tab shortcut wouldn't work while in edit mode in the spreadsheet."
      "Fixes the Turtle export action page."
    ]
    improvement: [
      "Adds redirecting to login if no public spaces are available."
      "Allows using backspace in Spreadsheet to clear the contents of a selection."
      "Names Action pages buttons Close now to be more ambiguous."
      "Hides Action pages that write data for readonly users."
      "View editing and deletion respects the read/write user rights."
      "Removes the Taxonomy view in the default space setting."
      "Adds more tooltips on various buttons."
    ]
  "0.4.9":
    date: '6 Nov 2020'
    feature: [
      "Allows spaces to be set as 'Public' to be accessable for non-users."
      "Allows admins to reset user passwords in Spaces & Users."
    ]
    fix: [
      "Fixes tooltips on disabled buttons to stick in Chrome."
      "Fixes issue where destroying an Element would sometimes freeze the app."
      "Fixes an issue which prevented added Functions to Roles."
      "Fixes an issue where opening elements in a table with alternative member key would cause crash."
    ]
    improvement: [
      "Disables Name functions for better consistency."
      "Allows menu options in Spaces and Users to overlap the Feedback button."
      "Changes Space Settings to respect user read/write abilities."
      "Shows the Add View button on hover more quickly."
    ]
  "0.4.8":
    date: '31 Oct 2020'
    feature: [
    ]
    fix: [
    ]
    improvement: [
      "Adds ability to set the space id upon space creation."
      "Improves various visual improvements."
    ]
  "0.4.7":
    date: '31 Oct 2020'
    feature: [
      "Adds automatical styling for HTML in attribute values."
      "Renders an image in the detail panel if a link points to an image."
      "Allows attributes via a relation to be viewed on the source Element."
    ]
    fix: [
      "Fixes an issue where certain action pages were unable to open."
    ]
    improvement: [
      "Adds autoscroll to the table when drag-selecting."
      "Adds shift-click for spreadsheet cell selection."
    ]
  "0.4.6":
    date: '29 Oct 2020'
    feature: [
    ]
    fix: [
      "Fixes an infinite loader on reload due to space permissions."
    ]
    improvement: [
      "Adds more logical sorting algorithm to full text searches."
      "Improves Action Page design and added helper buttons."
      "Removes the redundant more/less info in the detail panel."
    ]
  "0.4.5":
    date: '28 Oct 2020'
    feature: [
    ]
    fix: [
      "Fixes an encoding issue with ID containing a slash."
      "Fixes the Environment Settings button."
      "Fixes issue where changing the name of a space would sometimes fail."
    ]
    improvement: [
      "Removes option for Role ID in ACL management to be set and changed."
      "Removes the name key constraint to allow for special characters."
    ]
  "0.4.4":
    date: '27 Oct 2020'
    feature: [
      "Adds option to right click an element in the graph and get a shareable link."
      "Adds option to change a space member key in Space settings."
      "Adds option for space specific name keys in Space settings."
    ]
    fix: [
    ]
    improvement: [
      "Adds default space imports to use the same default type relation in all situations."
    ]
  "0.4.3":
    date: '26 Oct 2020'
    feature: [
      "Allows editing a single element through the pencil button in the detail panel."
    ]
    fix: [
      "Fixes an issue where user deletion would raise errors when done consecutively."
      "Fixes an issue where deleting a view would redirect to run the view."
      "Fixes an issue where the Views tree wouldn't be updated after deleting a view."
      "Fixes an issue where Imports or exports would halt when operation was not found."
    ]
    improvement: [
      "Adds a help button and information during View creation."
      "Adds an error messages when creating invalid spaces or users."
      "Renames Projects to Spaces in the Environment Settings view."
      "Improves readability for overlapping relations on the same node."
      "Adds elements in the $config graph to be filtered out by default."
      "Adds release dates for the SDK, Database and Server."
      "Adds various visual improvements."
    ]
  "0.4.2":
    date: '15 Oct 2020'
    feature: [
    ]
    fix: [
    ]
    improvement: [
      "Redesigns User Management to make it more user-friendly."
    ]
  "0.4.1":
    date: '14 Oct 2020'
    feature: [
      "Allows users to be set 'active' and 'inactive'."
      "Allows for views to be deleted by right clicking a view for its context menu."
    ]
    fix: [
      "Sets a user as 'active' by default when creating a user."
      "Removes the undefined user in the user list."
      "Fixes the 'Generate Turtle' action page."
    ]
    improvement: [
      "Shows 'more users' in the user access list if present."
    ]
  "0.4.0":
    date: '12 Oct 2020'
    feature: [
      "Respects Read and Write user rights throughout."
      "Adds ACL (Access Control Lists) functionality for Server Admins."
      "Adds View creation using Weaver Query by power users."
      "Exposes SPARQL endpoint with basic SPARQL constructs."
      "Allows Full Text Search working on element ID."
      "Supports filtering and sorting in table view."
    ]
    fix: [
      "Fixes an issue where relations in table view would hide when scrolling."
      "Fixes an issue where Open Node in Graph from type view would sometimes fail."
      "Fixes an issue where Open all nodes of type in table would sometimes fail."
      "Fixes various other bugs."
    ]
    improvement: [
      "Adds more Action Pages for import/export to the default space."
      "Removes requirement to focus for selection for boolean table cell."
    ]
  "0.3.3":
    date: '24 Aug 2020'
    feature: [
      "Adds option to freeze a graph to prevent the elements from moving."
    ]
    fix: [
      "Fixes various bugs spotted by automated tests."
      "Fixes a memory issue."
      "Fixes user access to certain spaces."
      "Fixes an issue where the table view would not load all nodes sometimes."
    ]
    improvement: [
    ]
  "0.3.2":
    date: '22 Jul 2020'
    feature: [
    ]
    fix: [
      "Fixes an issue with the lock popover."
      "Fixes infinite redirect on login page."
    ]
    improvement: [
      "Shows release Notes dates for the SDK releases."
    ]
  "0.3.1":
    date: '20 Jul 2020'
    feature: [
    ]
    fix: [
      "Fixes an issue with the Graph View being zoomed out."
      "Fixes an issue where some spaces with deleted data would not load the Type detail view."
      "Fixes an issue where navigating to the login page while logged in would not redirect."
    ]
    improvement: [
    ]
  "0.3.0":
    date: '16 Jul 2020'
    feature: [
      "Adds searching / filtering in the graph view."
      "Allows creating relations through a target search."
      "Adds relations to the table view."
      "Allows elements to have labels added and removed for grouping purposes."
      "Allows Filter panel for filtering on labels and on graphs."
      "Allows full database search with Ctrl/Cmd + K, on ID and first name key."
      "Allows detail view to optionally show incoming and outgoing relations."
      "Adds a feedback button to improve the app."
      "Adds ability to destroy relations by right click in context menu."
      "Adds option to edit attributes in the detail panel using the pencil button."
      "Adds setting to make relations in the graph hide by default."
      "Adds clickable attribute values matching hyperlinks."
      "Adds version log for the SDK, Server and Database in the changelog."
      "Adds destroying a node by deleting a row in the table view."
    ]
    fix: [
      "Fixes an issue where null and false values would not show in the detail panel."
      "Fixes an issue with the disabled relations setting."
      "Fixes an issue where table behaviour was strange when left panel was collapsed."
      "Fixes an issue where an empty relation in element creation would cause a crash."
      "Fixes an issue where type view would show deleted nodes in certain cases."
      "Restores page title when logging out."
      "Fixes an issue where recursive relations in the tree would make the tree crash."
      "Adds consistent use of the name and relation name accross the app."
      "Fixes an issue where changing an element name would sometimes change the color."
      "Fixes an issue where editing attributes would render according to type."
    ]
    improvement: [
      "Redesignes and improves the filter view."
      "Improves performance of the types view."
      "Drastically improved table performance."
      "Adds limitation for Graph view relations against render crash."
      "Sorts attributes in the detail panel alphabetically."
      "Supports Table showing relations of relations."
      "Shows time of date attributes when not 00:00."
      "Supports element graphs as means of grouping app-wide."
      "Allows pasting foreign elements for creation in Table view."
      "Tree view supports incoming and outgoing relations simultaneously."
      "Adds table cells rendering according to attribute types."
      "Element creation allows changing the name key."
      "Element creation allows changing the default generated id."
      "Improves left panel visually."
      "Adds auto-stretching to the tree view panel height."
      "Allows closing while creating elements using the ESC key."
      "Allows same ID to be used for element name rendering."
    ]
  "0.2.6":
    date: '22 May 2020'
    feature: [
      "Adds the concept of 'Action Pages' to initiate Hyperflows."
      "Adds elements with unreadable ID's and no names will appear as [ blank ]."
      "Table view allows creating new elements by typing in a new row."
      "Allows creating nodes with right-click in the graph view."
      "Allows creating relations with drag and drop in the graph view."
      "Allows destroying elements through the element context-menu."
    ]
    fix: [
      "Fixes an issue where elements with a number as name would not show the name."
      "Fixes an issue where opening the filter would sometimes hide typeless nodes."
      "Fixes bugs related to viewing element names and relations."
      "Fixes column stretching in the table view."
      "Fixes an issue where uneditable cells would allow editing when pasting data."
    ]
    improvement: [
      "Improves showing ID's in the graph view."
      "Improves the login screen."
      "Adds popovers to explain distribution labels in the type view."
      "Adds table view to show ID of elements when no other keys are present."
    ]
  "0.2.5":
    date: '11 May 2020'
    feature: [
    ]
    fix: [
      "Fixes bug in expanding tree caused by newer ant.d library."
      "Fixes some column width bugs in the Table."
      "Fixes various issues regarding editing in the Table."
    ]
    improvement: [
    ]
  "0.2.4":
    date: '6 May 2020'
    feature: [
      "Shows relations and  attributes in the detail panel."
      "Shows the relation ID when hovering over the relation name."
    ]
    fix: [
      "Labels blank nodes in the tree and the detail panel."
    ]
    improvement: [
      "Adds wider filter panel for better visibility."
    ]
  "0.2.3":
    date: '4 May 2020'
    feature: [
    ]
    fix: [
      "Fixes various table edit functionality."
      "Fixes relation nodes filtering."
    ]
    improvement: [
      "Improves graph performance due to proper cleanup."
      "Improves various design aspects."
    ]
  "0.2.2":
    date: '28 Apr 2020'
    feature: [
      "Adds nodes with no name attribute candidate to reveal their type in brackets."
      "Makes relation nodes visible including their relations."
      "Allows naming of nodes through a name function."
      "Adds Discard or Save confirmation for editing in the table."
    ]
    fix: [
      "Fixes scrolling in the detail panel."
    ]
    improvement: [
      "Improves editing in the table."
      "Improves performance on the filter popover."
      "Improves various design aspects of the app."
    ]
  "0.2.1":
    date: '21 Apr 2020'
    feature: [
      "Adds a more user-friendly design for the login page."
      "Allows cells edited in table to be saved."
    ]
    fix: [
    ]
    improvement: [
    ]
  "0.1.8":
    date: '15 Apr 2020'
    feature: [
      "Adds typing in Table cells, yet it is not being saved at this time."
    ]
    fix: [
      "Fixes an issue where filtering types in graph view was broken."
      "Fixes an issue where the Lock button would move away from the bottom in some cases."
    ]
    improvement: [
    ]
  "0.1.7":
    date: '14 Apr 2020'
    feature: [
    ]
    fix: [
      "Fixes an issue where table scrolling would misplace line up of header borders."
    ]
    improvement: [
      "Improves several visual aspects."
    ]
  "0.1.6":
    date: '9 Apr 2020'
    feature: [
      "Adds Sentry integration allowing for faster bug fixing."
      "Adds Segment integration allowing for more effective UX improvements."
      "Adds Cypress end-to-end testing integration for faster CD/CI."
    ]
    fix: [
      "Fixes an issue where locking the left panel would initially block the arrow keys."
      "Fixes an issue where the Tree nodes would move to the left when expanding."
      "Fixes an issue where opening the console and resizing would cause a crash."
    ]
    improvement: [
      "Improves displaying long project titles to fit the screen."
      "Improves peformance for expanding the Types tree node."
    ]
  "0.1.5":
    date: '8 Apr 2020'
    feature: [
      "Adds displaying the ID of elements when hovering over the name in detail panel."
      "Shows raw attribute keys when hovering over in detail panel."
    ]
    fix: [
      "Fixes an issue where the Graph view would crash on certain node movements."
      "Fixes an issue where hitting the left key would crash while moving the left panel."
      "Opens the right type when viewing a Table from the Type node."
      "Fixes an issue where the attribute panel would crash if Creator is unnamed."
    ]
    improvement: [
      "Shortens long attribute keys in detail panel."
      "Changes visibility of the count of nodes and relations in Type view."
      "Alligns Table headers to the left."
      "Changes displayed length when hovering the distribution value."
    ]
  "0.1.4":
    date: '6 Apr 2020'
    feature: [
      "Introduces Tables! Allows opening nodes of a certain type in a Table."
      "Adds option to right click a node in the graph for a Context Menu."
      "Adds View Type and Creator/Created in the detail panel."
      "Allows to double click a Type in the Type View to expand that Type."
      "Adds Unique and Single tags to replace the progress bar for a Type."
      "Allows hovering over a relation when hidden to read the label in the graph."
      "Adds download option to attributes that point to a file in MiniIo."
    ]
    fix: [
      "Translates all Dutch popups to English."
      "Fixes an issue where Types view would sometimes crash on color selection."
    ]
    improvement: [
      "Adds autofocus on search input when opening the project switcher."
      "Adds limit of 100 to distribution of attributes, showing the limit and total."
      "Improves thickness of relations in Types view to be more even."
      "Relation label in Types view is improved, all equal."
      "Adds more distance between the types for better readability."
      "Shows Type color in the graph filter panel, acts as legend."
      "Improves Home view to always have Types on top."
      "Improves Home view to place all queries under Views."
    ]
  "0.1.3":
    date: '30 Mar 2020'
    feature: [
      "Adds types tab which lists all types."
    ]
    fix: [
      "Fixes an issue where filter panel would crash if no model was selected."
      "Fixes an issue where listing all types in type filter wouldn't work if a type is a member of a type."
      "Fixes an issue where wrong project would get selected for users with limited access."
      "Fixes authentication error not showing in English."
      "Fixes an issue where zooming would explode the navigation buttons."
      "Fixes an issue where Instance and Home tree would break nodes when the text is too long."
      "Fixes an issue where restoring selected project from localstorage would crash."
    ]
    improvement: [
      "Changes visual design of the changelog."
      "Allows project selection to use the Weaver project name."
      "Sorts projects in alphabetical order."
      "Allows for longer Project list with more projects."
      "Increases loading speed when switching projects."
      "Adds consistent graph filter settings and improved default values."
    ]
  "0.1.2":
    date: '24 Mar 2020'
    feature: [
      "Shows the details of a relation when clicked from the graph."
      "Adds alphabetical sorting of nodes in the Elements tree."
      "Adds virtualized scroll in the Elements tree."
      "Saves the Home tree structure state of the queries per user."
      "Adds a 'Freeze element locations' in the filter menu."
      "Adds a 'Show identifiers for nameless elements' in the filter menu."
      "Adds a 'Hide relation labels' in the filter menu."
      "Adds a count of nodes and relations in the filter menu."
      "Adds a Changelog."
    ]
    fix: [
      "Fixes an issue where clicking nodes did activate the attribute view when lock state changed."
      "Fixes an issue where expired authentication token did not redirect to the login page."
      "Fixes an issue where large queries were causing unexpected side-effects in the graph view."
      "Fixes an issue where resizing the window would cause a crash in the infinite tree."
      "Fixes an issue where the project switcher was moving unexpectedly."
      "Fixes an issue where switching projects wasn't clearing all data from previous project."
    ]
    improvement: [
      "Improves various UX aspects."
      "Provides visual feedback when switching projects."
      "Removes the black sidebar, moved buttons to project switcher."
      "Removes the  error messages during login."
      "Adds project alias in the project switcher."
      "Adjusts the error page content."
      "Adds a Weaver loading animation."
      "Removes the alt keymap."
      "Removes all helper notifications."
      "Removes non-functional features such as favorites and model."
      "Makes the scrollbar more clean and slick."
      "Allows ESC to close any open/active window or popup."
      "Removes the tooltip of the filter window when opened."
      "Shows the type name in the filter window."
      "Clears the attributes view when a new query is run."
      "Ignores case when searching for projects."
      "Selects the next possible project when the project id is not found."
    ]

  "0.1.1":
    date: '16 Mar 2020'
    feature: [
      "Adds project switcher with a searchbar."
      "Allows using the ALT button to show a shortkey keymap."
    ]
    fix: [
    ]
    improvement: [
      "Changes Navigation letters to become clear icons."
      "Changes Nodes to become Elements in the whole application."
      "Removes re-ordering from items when filtering relations and types before closing the popup."
    ]

  "0.1.0":
    date: '5 Mar 2020'
    feature: [
      "Initial Release."
    ]
    fix: [
    ]
    improvement: [
    ]
}
